import Vue from 'vue'

// Define application holder.
let app = null;

// Define application event bus.
const eventBus = new Vue();

// Vue-resource plugin for communication with REST-api.
import VueResource from 'vue-resource'
Vue.use(VueResource);

// Add filters to the vue instance.
import {
    telephoneFilter,
    dateFilter,
    timeFilter
} from './utils.js'

Vue.filter('dateFilter', dateFilter);
Vue.filter('timeFilter', timeFilter);
Vue.filter('telephoneFilter', telephoneFilter);

// Add mixins.
import {
    debounce
} from './utils.js'

Vue.mixin({
    methods: {
        debounce,
    },
});

// CSS.
require('material-icons/css/material-icons.css');
require('../css/style.scss');
require('../css/datepicker.scss');

// Set moment library locale.
moment.locale('pl');

// Vue-resource and CSRFToken config: https://github.com/pagekit/vue-resource/blob/develop/docs/config.md
import {
    getCookie
} from './utils.js'

import {
    API_ROOT
} from './constants.js'

Vue.http.options.root = API_ROOT;
Vue.http.interceptors.push((request, next) => {
    request.headers.set('X-CSRFToken', getCookie('csrftoken'));

    // Always append 'access_token' parameter to the request, which is vital for the proper API work.
    const queryParams = new URLSearchParams(window.location.search);
    request.params['access_token'] = queryParams.get('access_token') || '';

    // Set up default actions depending on returned status code from API.
    next(response => {
        if (response.status === 500) {
            app.$app.$defaultServerErrorAction();
        }
    });
});

// Vue-router plugin setup.
import VueRouter from 'vue-router'
import router from './router.js'

Vue.use(VueRouter);

router.beforeEach((to, from, next) => {
    // Prepare nicescroll to reinitialization, so remove it first from body.
    $("body").getNiceScroll().remove();

    // Always append 'access_token' query parameter on route change.
    if (!to.query.access_token) {
        const extendedQuery = Object.assign(to.query, {access_token: from.query.access_token});
        next({...to, query: extendedQuery});
    } else {
        next();
    }
});

router.afterEach(() => {
    // Initialize custom document scrollbar on every route change, otherwise nicescroll has weird behaviour, namely
    // scrollbar which in some cases is necessary, suddenly disappears and its usability returns only on window resize.
    $("body").niceScroll({
        cursorcolor: 'rgba(195, 195, 195, 0.85)',
        cursorborder: '1px solid transparent',
        cursorborderradius: '3px',
        scrollspeed: 55,
        mousescrollstep: 60,
    });
});

// Define global object '$bus', which is a central event bus for the parent/child communication.
Object.defineProperty(Vue.prototype, '$bus', {
    get() {
        return eventBus;
    }
});

// And finally start the application!
app = new Vue({
    el: '#app',
    router: router,
    template: '<div id="root"><router-view></router-view></div>',
});

// Define global object '$store', containing reference to the main component App (not router).
Object.defineProperty(Vue.prototype, '$app', {
    get() {
        // Yeah it's ugly, but can't figure it out, how to make it better when vue-router is on.
        return app.$root.$children[0];
    }
});

// Define global object '$store', containing variables essential for proper work of specific components.
Object.defineProperty(Vue.prototype, '$store', {
    get() {
        // Yeah it's ugly, but can't figure it out, how to make it better when vue-router is on.
        return app.$root.$children[0].store;
    }
});

//Prevent new properties from being added to objects below and mark all their existing properties as non-configurable.
Object.seal(Vue.prototype.$bus);
Object.seal(Vue.prototype.$store);



// WEBPACK FOOTER //
// ./src/main.js